import { escapeRegExp } from 'lodash';

/**
 * @param {number} num
 * @return {string}
 */
export const getCellLetter = (num) => {
    const numLetters = 26;
    let output = '';
    for (let a = 1, b = numLetters; (num -= a) >= 0; a = b, b *= numLetters) {
        const n = parseInt((num % b) / a, 10);
        output = String.fromCharCode(65 + n) + output;
    }
    return output;
};

/**
 * @param {import("@goodt-common/data").IQueryFilterInfo} options
 * @return {import("@goodt-common/data").IQueryFilterInfo}
 */
export const createFilterInfo = ({ name = '', operator = '', value = [''] } = {}) => ({ name, operator, value });

/**
 * @param {import("@goodt-common/data").IQuerySortInfo} options
 * @return {import("@goodt-common/data").IQuerySortInfo}
 */
export const createSortInfo = ({ name = '', direction = '' } = {}) => ({ name, direction });

/**
 * @param {import("@goodt-common/data").IDatasetQueryDrilldown} options
 * @return {import("@goodt-common/data").IDatasetQueryDrilldown}
 */
export const createDrilldown = ({ name = '', dimensions = [] } = {}) => ({ name, dimensions });

/**
 * @param {string} value
 * @param {string} type
 * @return {string}
 */
export const formatFilterOperatorValue = (value, type) => {
    const nonQuotedTypes = ['INTEGER', 'INT', 'DOUBLE', 'FLOAT', 'BOOLEAN'];
    return nonQuotedTypes.includes(type.toUpperCase()) ? value : `'${value}'`;
};

export const buildDatasetNameRe = (query) => {
    const partOneSource = query != null ? `(${escapeRegExp(query)})` : /^(.+)/.source;
    const partTwoSource = /\s\(([0-9]+)\)$/.source;
    return new RegExp(`${partOneSource}${partTwoSource}`);
};
